import React from 'react';
import { TabStyled } from '../../asset/styled/component/TabStyled';

const Tab = ({ label, selectedTab, onClick }) => {
  return (
    <TabStyled selectedTab={selectedTab} onClick={onClick}>
      {label}
    </TabStyled>
  );
};

export default Tab;
